import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { MedewerkerType as Role } from "../../enums";

/** True als de toetsaanslag in een tekstveld plaatsvindt; dan geen globale shortcuts. */
export function isEditableTarget(e: KeyboardEvent): boolean {
  const target = e.target;
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}

/**
 * Globale sneltoetsen voor ingelogde gebruikers.
 * Ctrl+D / Cmd+D: naar het dashboard — manager-dashboard voor
 * MANAGER/FINANCIELE_MANAGER/PM/ADMIN, persoonlijk dashboard voor de rest.
 */
export default function GlobalShortcuts() {
  const { hasRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!(e.ctrlKey || e.metaKey) || e.shiftKey || e.altKey) return;
      if (e.key.toLowerCase() !== "d") return;
      if (isEditableTarget(e)) return;
      e.preventDefault();
      // Al op een dashboard: niets doen (wel de browser-bladwijzer blokkeren).
      if (
        location.pathname === "/dashboard" ||
        location.pathname === "/manager-dashboard"
      ) {
        return;
      }
      // ARTS eerst: wie arts én manager is gaat naar het persoonlijke dashboard.
      if (hasRole(Role.ARTS)) {
        navigate("/dashboard");
      } else if (
        hasRole(Role.MANAGER, Role.FINANCIELE_MANAGER, Role.PM, Role.ADMIN)
      ) {
        navigate("/manager-dashboard");
      } else {
        navigate("/dashboard");
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [hasRole, navigate, location.pathname]);

  return null;
}
